import React, {ReactNode, ChangeEvent} from 'react';
import I18n from 'app/i18n';

interface Props {
    changeAmount: (amount: string | number, isFixed: boolean) => void;
    amount: string;
    playmoney: boolean;
    bigBlind: number;
    currentBetAmount: number;
}

export default class PokerPanelButtonPokerGoBet extends React.Component<Props> {
    onChange = (event: ChangeEvent<HTMLInputElement>): void => {
        this.props.changeAmount(Number(event.target.value), false);
    };

    updateAmount = (delta: number): void => {
        const {changeAmount, currentBetAmount} = this.props;
        changeAmount(currentBetAmount + delta, true);
    };

    onPlusClick = (): void => {
        this.updateAmount(this.props.bigBlind);
    };

    onMinusClick = (): void => {
        this.updateAmount(-this.props.bigBlind);
    };

    render(): ReactNode {
        const {playmoney, amount} = this.props;

        return (
            <div className="poker-go-bet">
                <label className="field__label" htmlFor="pokerBetInput">
                    {I18n.t('bet_amount')}
                </label>
                <label className="symbol-label" htmlFor="pokerBetInput">
                    {playmoney ? 'PM' : '$'}
                </label>
                <input
                    onChange={this.onChange}
                    className={`field__input bold${playmoney ? ' pm' : ''}`}
                    id="pokerBetInput"
                    type="text"
                    value={amount}
                />
                <button className="button-poker-go-bet bb-plus" onClick={this.onPlusClick}>
                    <b>+</b>
                </button>
                <button className="button-poker-go-bet bb-minus" onClick={this.onMinusClick}>
                    <b>-</b>
                </button>
            </div>
        );
    }
}
